<dacks-content>
  <div class="md:hidden">
    <h1 class="mu-heading-3 text-petrol-650 pb-3">{{displayWelcome}}</h1>
    <ng-container *ngTemplateOutlet="delivery_content; context: { breakPointExtension: '_small' }"></ng-container>
    <h2 class="pt-6 mu-heading-4 lg:mu-heading-2">{{ 'common.title_prominent' | translate }}</h2>
    <ng-container *ngTemplateOutlet="news_content; context: { breakPointExtension: '_small' }"></ng-container>
  </div>
  <div class="hidden md:block mx-auto lg:w-[var(--mixed-content-card-container-width)]">
    <h1 class="mu-heading-2 text-white pb-6">{{displayWelcome}}</h1>
    <mat-card class="min-h-87">
      <ng-container *ngTemplateOutlet="delivery_content; context: { breakPointExtension: '_large' }"></ng-container>
    </mat-card>
    <h2 class="pt-6 mu-heading-3">{{ 'common.title_prominent' | translate }}</h2>
    <ng-container *ngTemplateOutlet="news_content; context: { breakPointExtension: '_large' }"></ng-container>
  </div>

  <footer-spacing type="content" />
</dacks-content>

<ng-template #delivery_content let-breakPointExtension="breakPointExtension">
  <div class="grid grid-cols-[1fr_auto] gap-4 md:mt-4 mb-4">
    <div class="space-y-4">
      <h2 class="whitespace-nowrap mu-heading-4 md:mu-heading-3">{{ 'updates.title' | translate }}</h2>
      @if (appState.isPersonalized$ | async) {
        <mat-slide-toggle class="" [checked]="appState.isPersonalDeliveryFilter"
                          (change)="changePersonalFilterState($event)">{{'filter-group.personalize_toggle' | translate}}</mat-slide-toggle>
      }
    </div>
    <div class="flex justify-end items-start space-x-4">
      <a mat-button color="light" class="hidden sm:inline-flex" [attr.aria-label]="'delivery-all-items.annual_planning_title' | translate"
         href="{{'delivery-all-items.annual_planning_url' | translate}}" download="{{'delivery-all-items.annual_planning_download_title' | translate}}"
         rel="noopener noreferrer">
        <mat-icon svgIcon="fi-herunterladen-20"></mat-icon>
        <span>{{ 'delivery-all-items.annual_planning_title' | translate}}</span>
      </a>
      <!-- link nur mit Icon kann nicht im DACKL Style dargestellt werden. Deshalb die Alternative Button -->
      <button mat-fab class="sm:hidden flex-shrink-0" [attr.aria-label]="'delivery-all-items.annual_planning_title' | translate" color="light" (click)="linkToAnnualPlanning()">
        <mat-icon svgIcon="fi-herunterladen-20"></mat-icon>
      </button>
    </div>
  </div>

  <p class="text-sm md:text-base break-words mb-4">{{'delivery.legal_notice' | translate}}</p>
  @if ((deliveryDescriptionsByDateCategory$ | async); as deliveryDescriptionsByDateCategory) {
    <div>
      @if (deliveryDescriptionsByDateCategory.categories.length === 3 && (
        deliveryDescriptionsByDateCategory.categories[0].deliveries.length > 0 ||
        deliveryDescriptionsByDateCategory.categories[1].deliveries.length > 0 ||
        deliveryDescriptionsByDateCategory.categories[2].deliveries.length > 0)) {

        <dackl-accordion displayMode="light">
          @for (category of deliveryDescriptionsByDateCategory.categories; track category) {
            <dackl-expansion-panel headline="{{category.categoryName}}"
                                   [id]="'panel' + breakPointExtension + ' ' + category.categoryName"
                                   [expanded]="pageState.expandedPanelId === (category.categoryName)"
                                   (opened)="onPanelOpened(category.categoryName)">

              @if (category.deliveries.length > 0) {
                <div class="hidden md:block">
                  <myupdates-delivery-items-table-view
                    [deliveries]="category.deliveries"
                    [categoryName]="category.categoryName"
                    [breakPointExtension]="breakPointExtension">
                  </myupdates-delivery-items-table-view>
                </div>
                <div class="md:hidden mt-3 flex flex-col gap-4">
                  @for (deliveryDescription of category.deliveries; track deliveryDescription) {
                    <div
                      role="region" [attr.aria-label]="(deliveryDescription.deliveryDate | date:'dd.MM.yyyy') + ' - ' + (deliveryDescription.deliveryName)">
                      <mat-card class="flex flex-row items-center p-4 relative show-focus h-30" [tabindex]="deliveryDescription.totalProducts > 0 &&
                                deliveryDescription.deliveryType !== DeliveryType.CompactRelease ? -1 : 0">
                        <div class="grow flex flex-col min-w-0">
                          <div class="mb-1 font-medium">
                            {{ deliveryDescription.deliveryDate | date:'dd.MM.yyyy' }}
                          </div>
                          <div>
                            <div class="hidden sm:block truncate" [ngClass]="{'font-semibold': (deliveryDescription.deliveryType === DeliveryType.MainRelease ||
                                   deliveryDescription.deliveryType === DeliveryType.CompactRelease)}"
                            >{{deliveryDescription.deliveryName}}</div>
                            <div class="sm:hidden truncate"
                                 [ngClass]="{'font-semibold': (deliveryDescription.deliveryType === DeliveryType.MainRelease ||
                                     deliveryDescription.deliveryType === DeliveryType.CompactRelease)}"
                            >{{deliveryDescription.deliveryName}}</div>
                          </div>
                          @if (deliveryDescription | numberProducts; as totalNumberProducts) {
                            <div>
                              {{ 'delivery-all-items.total_programs_small' | translate }} {{ totalNumberProducts }}
                            </div>
                          }
                        </div>
                        <div class="flex flex-row w-5">
                          @if (deliveryDescription.totalProducts > 0 && deliveryDescription.deliveryType !== DeliveryType.CompactRelease) {
                            <a
                              class="no-underline outline-none" aria-label="Mehr zum Update-Termin"
                              [routerLink]="deliveryDescription.routerLink" id="md:a_{{deliveryDescription.id}}" tabindex="0">
                              <mat-icon svgIcon="sli-pfeil-rechts-20" aria-hidden="true"></mat-icon>
                              <span class="absolute inset-0 z-[2]"></span>
                            </a>
                          }
                        </div>
                      </mat-card>
                    </div>
                  }
                </div>
              } @else {
                <div class="py-6 text-center font-semibold">
                  {{ 'delivery-all-items.empty_delivery_list' | translate }}
                </div>
              }

            </dackl-expansion-panel>
          }
        </dackl-accordion>
      } @else {
        <div class="pt-12 text-center font-semibold">
          {{ 'delivery-all-items.empty_delivery_list' | translate }}
        </div>
      }
    </div>
  } @else {
    @if (errorInfoForDeliveries$ | async) {
      <myupdates-error-box class="error-box-dimmed-style"
                           [errorTitle]="'delivery-all-items.error_title' | translate"
                           [errorText]="'delivery-all-items.error_text' | translate">
      </myupdates-error-box>
    } @else {
      <mat-spinner class="m-auto text-petrol-500"></mat-spinner>
    }
  }
</ng-template>

<ng-template #news_content let-breakPointExtension="breakPointExtension">
  <!--  über Membervariable: Jetzige Entscheidung / Sichtweise -->
  @if ((newsItems$ | async); as newsItems) {
    <div>
      <!-- zusätzliches DIV für Liste -->
      @if ((newsItems?.length ??-1)>0 ) {
        <div class="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-6 pt-3 md:pt-5">
          @for (newsItem of newsItems; track newsItem; let pcnr = $index) {
            <div>
              @if (newsItem.id && newsItem.detail.id) {
                <div role="region" [attr.aria-label]="newsItem.detail.title">
                  <!-- in der eingesetzten tailwind version wird max-h-none noch nicht unterstützt - md:max-h-none -->
                  <mat-card class="show-focus flex flex-col justify-between pl-4 pr-3 max-h-[15.813rem] h-[15.813rem]
                      py-6 relative">
                    <div class="flex flex-col text-[#0F0F0F] whitespace-normal">
                      @if (newsItem.scope === informationScope.Release) {
                        <a class="no-underline outline-none"
                           [attr.aria-label]="'Mehr zu ' + newsItem.detail.title" (click)="onClickCard(newsItem)"
                           routerLink="/product-change/details/{{newsItem.detail.id}}" [id]="'a_' + breakPointExtension + newsItem.detail.id" tabindex="0">
                          <h3 [id]="'heading_' + pcnr + breakPointExtension" class="mu-heading-5 whitespace-normal line-clamp-2">{{newsItem.detail.title}}</h3>
                          <span class="absolute inset-0 z-[2]"></span>
                        </a>
                      } @else {
                        <a class="no-underline outline-none" [attr.aria-label]="'Mehr zu ' + newsItem.detail.title"
                           (click)="onClickCard(newsItem)"
                           routerLink="/delivery/all-items/{{newsItem.detail.id}}" [id]="'a_' + breakPointExtension + newsItem.detail.id" tabindex="0">
                          <h3 [id]="'heading_' + pcnr + breakPointExtension" class="mu-heading-5 whitespace-normal line-clamp-2">{{newsItem.detail.title}}</h3>
                          <span class="absolute inset-0 z-[2]"></span>
                        </a>
                      }
                      <!-- Logik für Anzeige -->
                      @if (newsItem.scope === informationScope.Release && $any(newsItem.detail).deliveryDate) {
                        @if ($any(newsItem.detail).onlineProduct) {
                          <div class="text-sm">
                            {{'product-change-details.contained_in_month' | translate}} {{$any(newsItem.detail).deliveryDate | date:dateTranslationMonth }}
                          </div>
                        } @else {
                          <div class="text-sm">
                            {{'product-change-details.contained_in_short' | translate}} {{$any(newsItem.detail).deliveryDate | date:dateTranslation }}
                          </div>
                        }
                      }
                      @if (newsItem.scope === informationScope.Release) {
                        <myupdates-change-categories class="pt-1 pb-1"
                                                     [id]="'changeCat_' + pcnr + breakPointExtension"
                                                     [changeCategories]="$any(newsItem.detail).changeCategories"></myupdates-change-categories>
                      }
                      <div [ngClass]="{'mt-2': newsItem.scope === informationScope.Announcement}">
                        @if (newsItem.detail.teaser.length > 1) {
                          <ul id="{{'teasers_' + pcnr}}" class="items-center flex-grow truncate"
                              [ngClass]="getTeaserHeightValue('heading_' + pcnr + breakPointExtension,
                        newsItem.scope === informationScope.Release)">
                            @for (teaserLine of newsItem.detail.teaser; track teaserLine; let i = $index) {
                              <li>
                                <div class="[float:left] pl-1.5 pr-1.5" aria-hidden="true">&bull;</div>
                                <div id="{{'teasers_' + pcnr + '_' + i}}"
                                     class="home-prominent-teaser-list__item truncate whitespace-normal text-[1rem] pr-[1.781rem]"
                                     [ngClass]="{'single-line': isTeaserLineCutOff('teasers_' + pcnr + '_' + i, 'teasers_' + pcnr)}">{{teaserLine}}</div>
                              </li>
                            }
                          </ul>
                          <ng-container *ngTemplateOutlet="ellipsis"></ng-container>
                        } @else {
                          <div class="items-center flex-grow truncate whitespace-normal text-[1rem]"
                               [ngClass]="getTeaserLineClampValue('heading_' + pcnr + breakPointExtension,
                         newsItem.scope === informationScope.Release)">
                            {{newsItem.detail.teaser[0]}}</div>
                        }
                      </div>
                      <ng-template #ellipsis>
                        @if (isElementVerticalOverflow('teasers_' + pcnr)) {
                          <div>
                            <span class="pl-1.5 pr-1.5" aria-hidden="true">&bull;</span>...
                          </div>
                        }
                      </ng-template>
                    </div>
                    <div aria-hidden="true" class="flex flex-row items-center self-end absolute mt-[11.313rem]">
                      <div class="font-medium truncate">{{ 'home.caption_more' | translate }}</div>
                      <mat-icon svgIcon="sli-pfeil-rechts-20" aria-hidden="true"></mat-icon>
                    </div>
                  </mat-card>
                </div>
              }
            </div>
          }
        </div>
      } @else {
        <div class="pt-12 h-24 text-center font-semibold">
          {{ 'home.empty_product_change_list' | translate }}
        </div>
      }
    </div>
  } @else {
    @if (errorInfoForNews$ | async) {
      <myupdates-error-box class="error-box-white-style mt-4"
                           [errorTitle]="'home.error_prominent_title' | translate"
                           [errorText]="'home.error_prominent_text' | translate">
      </myupdates-error-box>
    } @else {
      <mat-spinner class="m-auto text-petrol-500"></mat-spinner>
    }
  }
</ng-template>
